import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';
import GreenButton from '../Shared/GreenButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useTranslation } from 'react-i18next';
import OrderStartEndDateComponent from './OrderStartEndDateComponent';
import FormikSelectField from 'formik-material-fields/lib/FormikSelectField';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';

export default function CreateOrderComponent(props) {
    const classes = useStyles();

    const [ordernumber, setOrdernumber] = useState(null)
    const [article, setArticle] = useState(null)
    const [articles, setArticles] = useState([])
    const [pieces, setPieces] = useState(null)
    const [salesorder, setSalesorder] = useState(null)
    const [client, setClient] = useState(null)
    const [workstations, setWorkstations] = useState([])
    const [workstation, setWorkstation] = useState(null)

    const { t } = useTranslation();

    useEffect(() => {
        let stations = props.workstations.map(x => { return ({ label: "WORKSTATION " + x.code, value: x.id }) })
        if (JSON.stringify(workstations) !== JSON.stringify(stations)) {
            setWorkstations(stations)
        }

        if (JSON.stringify(workstation) !== JSON.stringify(props.selectedWorkstation)) {
            setWorkstation(workstation)
        }
        dataService.getAllProducts().then(products => {
            products = products.filter(x => x.productGroupId === 1).map(x => { return ({ label: x.name, value: x.id }) })
            if (JSON.stringify(articles) !== JSON.stringify(products)) {
                setArticles(products)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [])

    function ordernumberChanged(e) {
        setOrdernumber(e.target.value)
    }

    function articleChanged(e) {
        setArticle(e.target.value)
    }

    function workstationChanged(e) {
        setWorkstation(e.target.value)
    }

    function piecesChanged(e) {
        setPieces(e.target.value)
    }

    function salesorderChanged(e) {
        setSalesorder(e.target.value)
    }

    function clientChanged(e) {
        setClient(e.target.value)
    }

    function createOrder() {
        let station = workstation
        if(station === null){
            station = props.selectedWorkstation
        }
        props.createOrder(props.maintenance,station,ordernumber,article,pieces,salesorder,client)
    }

    let shape = {}
    if (props.maintenance) {
        shape['ordernumber'] = Yup.string().required("Ordernumber is required")
    }
    else {
        shape['article'] = Yup.string().required("Article is required")
        shape['pieces'] = Yup.string().required("Pieces is required")
        shape['ordernumber'] = Yup.string().required("Ordernumber is required")
    }

    return (
        <div className={classes.createOrderContainer}>
            <Formik
                initialValues={{
                    ordernumber: '',
                    workstation:props.selectedWorkstation
                }}
                validationSchema={Yup.object().shape(shape)}
            >
                {({ isValid, touched }) => (

                    <Form autoComplete="off">
                        <div className={classes.orderInfo}>
                            <div className={classes.title}> Order info</div>
                            <div className={classes.label}>Order number</div>
                            <FormikTextField id="outlined-search" name="ordernumber" label="" type="search" value={""} className={classes.formikSelectField} size="small" onChange={(e) => ordernumberChanged(e)} />
                            <div className={classes.article}>
                                    <div className={classes.label} >Workstation</div>
                                    <FormikSelectField name="workstation" className={classes.formikSelectField} onChange={(e) => workstationChanged(e)} options={workstations} />
                                </div>
                            {!props.maintenance ?
                                <React.Fragment>
                                    <div className={classes.article}>
                                        <div className={classes.label} >Article</div>
                                        <FormikSelectField name="article" className={classes.formikSelectField} onChange={(e) => articleChanged(e)} options={articles} />
                                    </div>
                                    <div className={classes.label} >Pieces</div>
                                    <FormikTextField id="outlined-search" name="pieces" label="" type="number" onChange={(e) => piecesChanged(e)} className={classes.formikSelectField} size="small" InputProps={{
                                        endAdornment: <InputAdornment position="end">pieces</InputAdornment>, inputProps: { min: "0", step: "1" },
                                    }} />
                                    <div className={classes.label}>Sales order</div>
                                    <FormikTextField id="outlined-search" name="salesorder" label="" type="search" variant="outlined" value={""} className={classes.formikTextField} size="small" onChange={(e) => salesorderChanged(e)} />
                                    <div className={classes.label}>Client</div>
                                    <FormikTextField id="outlined-search" name="client" label="" type="search" variant="outlined" value={""} className={classes.formikTextField} size="small" onChange={(e) => clientChanged(e)} />
                                </React.Fragment>:
                                <React.Fragment></React.Fragment>
                            }
                        </div>
                        <OrderStartEndDateComponent start={props.start} end={props.end} handleFromDateChange={props.handleFromDateChange} handleTillDateChange={props.handleTillDateChange}></OrderStartEndDateComponent>
                        <div className={classes.createNewOrder}>
                            <GreenButton onClick={createOrder} text={"NEW PROJECT"} disabled={!isValid || Object.entries(touched).length === 0}></GreenButton>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    createNewOrder: {
        width: "100%",
        textAlign: "center",
        marginTop: "30px"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
    },
    formikTextField: {
        width: "100%",
        backgroundColor: "white",
        marginBottom: "10px"
    },
    formikSelectField: {
        width: "97%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "rgb(1,1,1,0)",
            display: 'block'
        },
        marginBottom: "15px"

    },
    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        marginBottom: "10px",
        marginTop: "20px"
    },
    orderInfo: {
        marginBottom: "20px"
    },
    option: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
    },
    article: {
        height: "fit-content",
        width: "100%"
    }
}));